const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "VESSEL_SUB_TYPES_RETRIEVED":
            return action.vesselSubTypes;

        default:
            return state;
    }
}
